import { AppSidebar } from '@/components/app-sidebar'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { Skeleton } from '@/components/ui/skeleton';
import { moduleDefinitionsQueryOptions } from '@/queries/moduleDefinitionsQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$module_id/$entity_type_id/segments')({
  component: RouteComponent,
})

function RouteComponent() {

  const { module_id } = Route.useParams();
  const modulesQuery = useQuery(moduleDefinitionsQueryOptions);
  const currentModule = modulesQuery.data?.find((module) => module.id === module_id);

  if (modulesQuery.isLoading) {
    return <Skeleton className="h-full w-full" />
  }


  return <>

    <SidebarProvider className="absolute left-12 top-0 h-full min-h-full">

      <AppSidebar currentModule={currentModule ?? {}} className="h-full left-12" />
      <SidebarInset className="bg-background pl-0 mr-13">
        <Outlet />
      </SidebarInset>

    </SidebarProvider>
  </>
}
//
